import { Navigate, Outlet } from "react-router-dom";
import { isLogin } from "../lib/constant";

export const PrivateRouterOutlet = () => {
  const is_authenticated = isLogin();


  return is_authenticated ? <Outlet /> : <Navigate to="/login" />;
};
